const { size } = require('../../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @param {string|number} validationValue
 * @returns {boolean}
 */
function minLength ({ value, validationValue }) {
  return size(value.toString()) >= parseInt(validationValue)
}

module.exports = { minLength }
